import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  DrawerBody,
  DrawerFooter,
  Alert,
  Typography
} from '@one-thd/sui-atomic-components';

import { GENERIC_ERROR } from '../shared/Constants';

const ErrorDrawer = ({ message = '', onClose }) => {
  return (
    <>
      <DrawerBody>
        <Alert status="error">
          <Typography>{message || GENERIC_ERROR}</Typography>
        </Alert>
      </DrawerBody>
      <DrawerFooter>
        <Button
          fullWidth
          variant="primary"
          onClick={onClose}
        >
          OK
        </Button>
      </DrawerFooter>
    </>
  );
};

ErrorDrawer.propTypes = {
  onClose: PropTypes.func.isRequired,
  message: PropTypes.string
};

ErrorDrawer.displayName = 'ErrorDrawer';

export { ErrorDrawer };